import './index.scss'

$(document).scroll(function () {
  if($('.ny-banner .bg-img').length > 0){
    var scroH = $(document).scrollTop(); //滚动高度
    $('.ny-banner .bg-img').css('transform','translateY('+ scroH / 3 +'px)')
  }
});